import { render, staticRenderFns } from "./opportunity-budget-request.vue?vue&type=template&id=93a5f952"
import script from "./opportunity-budget-request.ts?vue&type=script&lang=ts&external"
export * from "./opportunity-budget-request.ts?vue&type=script&lang=ts&external"
import style0 from "./opportunity-budget-request.scss?vue&type=style&index=0&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('93a5f952')) {
      api.createRecord('93a5f952', component.options)
    } else {
      api.reload('93a5f952', component.options)
    }
    module.hot.accept("./opportunity-budget-request.vue?vue&type=template&id=93a5f952", function () {
      api.rerender('93a5f952', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/budget-request/opportunity-budget-request/opportunity-budget-request.vue"
export default component.exports